var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 286.001,
    viewBox: "0 0 288 286.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6227",
    "data-name": "Group 6227",
    transform: "translate(-21794.221 -20280.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rocks",
    transform: "translate(21794.221 20523.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15235",
    "data-name": "Path 15235",
    d: "M135.142,389.5s.834-9.8-3.1-10.386-.3,9.01-.3,9.01-4.089-5.128-6.825-2.838,6.811,6.284,6.811,6.284Z",
    transform: "translate(-95.234 -379.086)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6162",
    "data-name": "Group 6162",
    transform: "translate(0 6.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6160",
    "data-name": "Group 6160",
    transform: "translate(198.022 10.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15236",
    "data-name": "Path 15236",
    d: "M327.145,411.52S339.593,399.5,341.666,399.5s18.093.415,25.63,0,15.829,7.048,22.462,12.023,24.461,9.536,24.461,9.536l2.9,4.56H327.145Z",
    transform: "translate(-327.145 -399.48)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15238",
    "data-name": "Path 15238",
    d: "M417.124,425.619H327.15v-14.1S339.6,399.5,341.669,399.5c.431,0,1.451.017,2.869.041A13.133,13.133,0,0,0,360,411.556c.066-.008.124-.025.191-.033,3.06-.556,13.474,1.036,16.791,6.426s19.154,4.784,19.154,4.784,14.477.663,20.572,2.23Z",
    transform: "translate(-327.146 -399.483)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6161",
    "data-name": "Group 6161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15239",
    "data-name": "Path 15239",
    d: "M177.669,409.907S163.3,389.73,159.7,387.519s-17.137,1.382-26.258,1.382-14.372,12.882-19.9,15.2S89.223,423.45,89.223,423.45h93.421Z",
    transform: "translate(-89.221 -386.8)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15240",
    "data-name": "Path 15240",
    d: "M177.669,409.907S163.3,389.73,159.7,387.519s-17.137,1.382-26.258,1.382-14.372,12.882-19.9,15.2S89.223,423.45,89.223,423.45h93.421Z",
    transform: "translate(-89.221 -386.8)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15242",
    "data-name": "Path 15242",
    d: "M182.643,423.52H89.22s.605-.547,1.625-1.459c4.743-.622,15.423-2.172,18.308-3.93,3.74-2.28,21.758-4.56,30.879-3.109s8.706-12.645,13.267-16.376c2.786-2.28,4.544-7.628,5.481-11.434a3.339,3.339,0,0,1,.92.381c3.6,2.206,17.968,22.388,17.968,22.388Z",
    transform: "translate(-89.22 -386.87)",
    opacity: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(21829.32 20280.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15246",
    "data-name": "Path 15246",
    d: "M329.142,399.123s-1.969-9.639,1.866-10.676,1.347,8.914,1.347,8.914,3.464-5.569,6.448-3.614-6.033,7.034-6.033,7.034Z",
    transform: "translate(-165.218 -137.719)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6170",
    "data-name": "Group 6170",
    transform: "translate(56.811 228.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15247",
    "data-name": "Path 15247",
    d: "M211.188,371.418s-.782-9.808-4.754-9.74,1.178,8.938,1.178,8.938-4.872-4.39-7.2-1.683,7.748,5.085,7.748,5.085Z",
    transform: "translate(-200.067 -361.679)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6171",
    "data-name": "Group 6171",
    transform: "translate(35.328 222.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15249",
    "data-name": "Path 15249",
    d: "M174.158,417.951s11.055-33.443,16.584-36.65c12.121-7.031,20.533-22.033,22.388-23.05,8.725-4.789,40.593-4.1,52.911-2.188s22.545,29.659,29.731,30.572,21.006,18.05,21.835,19.708,0,11.609,0,11.609H174.158Z",
    transform: "translate(-174.158 -354.612)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15251",
    "data-name": "Path 15251",
    d: "M312.955,389.565a95.684,95.684,0,0,0-10.821-.033,169.93,169.93,0,0,1-20.041-.141c-3.035-.116.3-6.277,5.746-8.723a84.724,84.724,0,0,0,12.3-7.048C305.036,380.651,309.348,387.948,312.955,389.565Z",
    transform: "translate(-192.399 -357.859)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15252",
    "data-name": "Path 15252",
    d: "M314.079,426.941H189.91c6.343-4.478,21.26-14.436,28.905-14.652,9.867-.274,19.66,8.847,31.2,4.7s27.739-9.982,35.567-9.743C300.311,407.7,311.21,418,314.079,426.941Z",
    transform: "translate(-176.849 -363.602)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6226",
    "data-name": "Group 6226",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15253",
    "data-name": "Path 15253",
    d: "M237.429,125.654c3.609-5.566,5.621-7.409,14.758-5.293s10.064-4.79,8.342-6.476-1.13-2.17-.228-3.776,1.415-2.552.789-3.676-1.158-1.863.276-3.608.368-7.36.368-7.36l-10.011-9.831s-6.843-.493-9.594,3.145-2.255,6.08-4.746,7.1c-2.173.887-2.617,3.725-2.318,5.329.374,2-.832,3.026-2.65,3.32a3.787,3.787,0,0,0-3.194,3.725,2.516,2.516,0,0,1-2.528,2.706,4.953,4.953,0,0,0-4.125,4.79c-.133,3.682-3.415,4.259-1.464,9.425C223.494,131.5,233.392,131.878,237.429,125.654Z",
    transform: "translate(-146.744 -85.612)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6173",
    "data-name": "Group 6173",
    transform: "translate(108.539 8.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15254",
    "data-name": "Path 15254",
    d: "M294.091,133.785a8.99,8.99,0,0,1-.092.993c-.014.092-.036.206-.064.333s-.064.263-.107.4-.106.333-.163.483l-.142.313a2.585,2.585,0,0,1-.177.333,4.864,4.864,0,0,1-1.561,1.682,4.942,4.942,0,0,1-1.469.66,5.264,5.264,0,0,1-.766.142c-.128.014-.249.022-.376.028h-.106l-.546-.014a4.5,4.5,0,0,1-.511-.042l-.731-.106-.589-.114c-.76-.17-1.376-.347-2-.525-1.214-.362-2.342-.752-3.456-1.15-2.207-.809-4.337-1.661-6.437-2.555-.22-.092-.447-.185-.667-.284-.774-.333-1.555-.674-2.321-1.015-.291-.128-.575-.255-.859-.391q-1.565-.7-3.109-1.448c-1.809-.859-3.6-1.753-5.386-2.69l1.107-11.007c3.982,1.852,11.476,5.663,15.429,7.58,1.867.894,3.74,1.8,5.585,2.626-.3-1.93-.66-3.91-1.015-5.883l-2.746-14.925,4.861-1.575c1.809,4.194,3.683,10.262,5.152,14.6.745,2.158,1.434,4.343,2.051,6.614.319,1.135.61,2.293.852,3.541.114.632.235,1.284.305,2.044A12.2,12.2,0,0,1,294.091,133.785Z",
    transform: "translate(-262.452 -97.697)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15255",
    "data-name": "Path 15255",
    d: "M272.028,136.79q-1.565-.7-3.109-1.448l-.142-7.288A39.227,39.227,0,0,0,271.61,136C271.759,136.258,271.9,136.527,272.028,136.79Z",
    transform: "translate(-263.533 -101.526)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6172",
    "data-name": "Group 6172",
    transform: "translate(6.405)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5103",
    "data-name": "Rectangle 5103",
    width: 24.884,
    height: 2.637,
    transform: "translate(1.553 3.414)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15256",
    "data-name": "Path 15256",
    d: "M283.941,106.3s-2.822-2.2-3.146-3.076,1.018-2.954,1.666-2.912c.909.06-.278,2.36-.278,2.36l5.575.166s1.064.109,1.041,1.89A5.765,5.765,0,0,1,283.941,106.3Z",
    transform: "translate(-271.982 -96.787)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15257",
    "data-name": "Path 15257",
    d: "M281.429,100.332s-.6-1.337.185-1.708a15.253,15.253,0,0,1,6.453.42c1.087.575.486,2.147-.347,2.343S282.424,102.064,281.429,100.332Z",
    transform: "translate(-272.061 -96.468)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5104",
    "data-name": "Rectangle 5104",
    width: 15.233,
    height: 5.836,
    transform: "translate(19.144 1.814)",
    fill: "#7b6bd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5106",
    "data-name": "Rectangle 5106",
    width: 22.381,
    height: 7.775,
    transform: "translate(28.905 0.844)",
    fill: "#9169df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5107",
    "data-name": "Rectangle 5107",
    width: 1.553,
    height: 9.842,
    transform: "translate(50.123)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5108",
    "data-name": "Rectangle 5108",
    width: 1.553,
    height: 9.842,
    transform: "translate(50.123)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5109",
    "data-name": "Rectangle 5109",
    width: 1.553,
    height: 3.823,
    transform: "translate(0 2.82)",
    fill: "#9169df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6224",
    "data-name": "Group 6224",
    transform: "translate(47.075 0.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6223",
    "data-name": "Group 6223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6191",
    "data-name": "Group 6191",
    transform: "translate(47.904 78.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6189",
    "data-name": "Group 6189",
    transform: "translate(14.363 133.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6188",
    "data-name": "Group 6188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15258",
    "data-name": "Path 15258",
    d: "M263.668,340.689l1.709,8.171h4.3l.471-8.171Z",
    transform: "translate(-263.462 -340.689)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6175",
    "data-name": "Group 6175",
    transform: "translate(0 6.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6174",
    "data-name": "Group 6174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15259",
    "data-name": "Path 15259",
    d: "M281.927,355.921c-.143-2.662-1.285-3.457-2.725-3.548a52.22,52.22,0,0,1-6.8-1.891s-1.063-1.691-2.037-2.034-1.964.663-1.964.663l-2.688-.329s-.768-1.216-1.361-.151c-.918,1.65-.968,6.219-.925,7.289h18.5Z",
    transform: "translate(-263.419 -348.194)",
    fill: "#407bff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6178",
    "data-name": "Group 6178",
    transform: "translate(0.041 8.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6177",
    "data-name": "Group 6177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6176",
    "data-name": "Group 6176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15260",
    "data-name": "Path 15260",
    d: "M281.609,355.739l-3.353-.016q-7.334-.036-14.668-.076c-.187,0-.139-.285.047-.281.329,0,.664,0,.993.006a.112.112,0,0,1,.017-.038,2.67,2.67,0,0,0-.87-3.869c-.15-.085.04-.335.183-.244a2.906,2.906,0,0,1,.965,4.149c.691.007,1.377.009,2.069.011q7.326.036,14.663.076C281.843,355.457,281.795,355.744,281.609,355.739Z",
    transform: "translate(-263.469 -351.201)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6181",
    "data-name": "Group 6181",
    transform: "translate(7.875 8.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6180",
    "data-name": "Group 6180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6179",
    "data-name": "Group 6179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15261",
    "data-name": "Path 15261",
    d: "M273.177,352.108a1.909,1.909,0,0,1,2.706-.474c.128.109.312-.137.186-.245-.906-.776-2.214-.439-3.112.576-.132.148.09.29.221.143Z",
    transform: "translate(-272.916 -350.963)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6184",
    "data-name": "Group 6184",
    transform: "translate(9.375 8.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6183",
    "data-name": "Group 6183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6182",
    "data-name": "Group 6182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15262",
    "data-name": "Path 15262",
    d: "M274.986,352.683a1.909,1.909,0,0,1,2.706-.474c.128.109.312-.137.186-.245-.906-.776-2.214-.439-3.112.576-.132.148.09.289.221.143Z",
    transform: "translate(-274.725 -351.538)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6187",
    "data-name": "Group 6187",
    transform: "translate(10.927 9.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6186",
    "data-name": "Group 6186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6185",
    "data-name": "Group 6185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15263",
    "data-name": "Path 15263",
    d: "M276.858,353.257a1.909,1.909,0,0,1,2.706-.474c.128.109.312-.137.186-.245-.906-.775-2.214-.439-3.112.576-.132.148.09.29.221.143Z",
    transform: "translate(-276.597 -352.112)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_15264",
    "data-name": "Path 15264",
    d: "M269.673,251.047c.036,22.108-2.215,64.334-2.215,64.334l-6.643.142s-11.114-37.785-7.069-63.937q-1.5-6.771-2.654-12.74-.714-3.673-1.3-7.055c-1.348-7.693-2.243-14.293-2.818-19.95-.206-1.98-.369-3.839-.5-5.593-1.483-20.553,1.824-26,1.824-26l18.069.071S269.617,214.825,269.673,251.047Z",
    transform: "translate(-246.098 -180.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15265",
    "data-name": "Path 15265",
    d: "M249.976,234.511c-1.348-7.693-2.243-14.293-2.818-19.95l2.569-18.4S251.814,218.677,249.976,234.511Z",
    transform: "translate(-246.279 -182.97)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6190",
    "data-name": "Group 6190",
    transform: "translate(13.521 133.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15266",
    "data-name": "Path 15266",
    d: "M270.95,344.516l.305-2.844H262.4l.4,2.844Z",
    transform: "translate(-262.404 -341.672)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6209",
    "data-name": "Group 6209",
    transform: "translate(27.694 79.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6207",
    "data-name": "Group 6207",
    transform: "translate(4.079 132.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6206",
    "data-name": "Group 6206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15267",
    "data-name": "Path 15267",
    d: "M226.848,340.8l1.733,8.118h4.3l.447-8.118Z",
    transform: "translate(-226.679 -340.799)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6193",
    "data-name": "Group 6193",
    transform: "translate(0 6.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6192",
    "data-name": "Group 6192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15268",
    "data-name": "Path 15268",
    d: "M245.156,355.932c-.152-2.645-1.3-3.434-2.736-3.525a52.591,52.591,0,0,1-6.8-1.878s-1.067-1.68-2.044-2.021-1.962.658-1.962.658l-2.69-.328s-.772-1.207-1.362-.149c-.914,1.639-.949,6.178-.9,7.242Z",
    transform: "translate(-226.644 -348.255)",
    fill: "#407bff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6196",
    "data-name": "Group 6196",
    transform: "translate(0.042 8.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6195",
    "data-name": "Group 6195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6194",
    "data-name": "Group 6194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15269",
    "data-name": "Path 15269",
    d: "M244.836,355.751l-3.353-.015q-7.334-.035-14.669-.076c-.187,0-.14-.284.046-.279.329,0,.664,0,.993.006a.108.108,0,0,1,.017-.037,2.648,2.648,0,0,0-.881-3.844c-.151-.085.038-.333.182-.242a2.882,2.882,0,0,1,.978,4.123c.691.007,1.377.009,2.069.011q7.327.035,14.663.076C245.069,355.471,245.022,355.755,244.836,355.751Z",
    transform: "translate(-226.695 -351.243)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6199",
    "data-name": "Group 6199",
    transform: "translate(7.866 8.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6198",
    "data-name": "Group 6198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6197",
    "data-name": "Group 6197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15270",
    "data-name": "Path 15270",
    d: "M236.392,352.142a1.916,1.916,0,0,1,2.7-.472c.128.109.312-.136.185-.243-.909-.771-2.215-.436-3.11.572-.131.148.091.289.221.143Z",
    transform: "translate(-236.131 -351.004)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6202",
    "data-name": "Group 6202",
    transform: "translate(9.368 8.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6201",
    "data-name": "Group 6201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6200",
    "data-name": "Group 6200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15271",
    "data-name": "Path 15271",
    d: "M238.2,352.714a1.915,1.915,0,0,1,2.7-.472c.128.109.312-.136.185-.243-.909-.77-2.215-.436-3.11.572-.131.149.091.289.221.143Z",
    transform: "translate(-237.942 -351.575)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6205",
    "data-name": "Group 6205",
    transform: "translate(10.921 9.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6204",
    "data-name": "Group 6204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6203",
    "data-name": "Group 6203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15272",
    "data-name": "Path 15272",
    d: "M240.076,353.285a1.915,1.915,0,0,1,2.7-.472c.128.109.312-.136.185-.244-.909-.77-2.215-.435-3.11.573-.131.148.091.289.221.143Z",
    transform: "translate(-239.815 -352.147)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_15273",
    "data-name": "Path 15273",
    d: "M221.764,207.238a269.768,269.768,0,0,0,1.565,32.38q.6,5.935,1.464,12.66c-6.491,25.984,1.095,63.523,1.095,63.523l6.654-.148s6.2-41.951,8.23-63.913c3.326-35.984,3.3-70.261,3.3-70.261l-18.064-.07S222.2,186.818,221.764,207.238Z",
    transform: "translate(-221.725 -181.408)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6208",
    "data-name": "Group 6208",
    transform: "translate(3.1 132.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15274",
    "data-name": "Path 15274",
    d: "M233.743,344.6l.572-2.825h-8.852l.139,2.825Z",
    transform: "translate(-225.463 -341.775)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_15276",
    "data-name": "Path 15276",
    d: "M227.714,157.216c.008-.945.008-1.915-.008-2.919-.008-.672-.017-1.352-.041-2.048l3.847-7.769-3.864,15.613C227.681,159.156,227.706,158.2,227.714,157.216Z",
    transform: "translate(-195.042 -95.775)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15277",
    "data-name": "Path 15277",
    d: "M219.653,122.949s-9.031,28.355-10.944,30.722c-3.093,3.826-20.384,14.27-20.384,14.27l.713,5.845s20.3-4.577,26.981-13.6c4.171-5.628,12.574-29.73,12.574-29.73Z",
    transform: "translate(-188.325 -92.007)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6222",
    "data-name": "Group 6222",
    transform: "translate(46.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15278",
    "data-name": "Path 15278",
    d: "M266.079,102.2s4.038-5.539.529-10.778a7.851,7.851,0,0,0-9.2-3.057Z",
    transform: "translate(-246.894 -86.022)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6210",
    "data-name": "Group 6210",
    transform: "translate(0 16.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15279",
    "data-name": "Path 15279",
    d: "M254.127,118.106a1.178,1.178,0,0,0,.126.274c1.161,1.831-1.022,5.185-1.022,5.185-.194-.014.187.037,0,0,0,0-3.031-2.415-3.528-2.954l-.007-.007a43.97,43.97,0,0,0-4.968-4.566c3-1.609,4.1-7.323,4.378-10.894l4.66,5.934.872,1.3a10.452,10.452,0,0,0-1.011,2.291C253.284,115.857,253.432,116.243,254.127,118.106Z",
    transform: "translate(-244.728 -105.144)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6211",
    "data-name": "Group 6211",
    transform: "translate(6.104 22.112)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15280",
    "data-name": "Path 15280",
    d: "M254.886,115.886A10.378,10.378,0,0,1,255.9,113.6l-.872-1.3-2.934.067A6.933,6.933,0,0,0,254.886,115.886Z",
    transform: "translate(-252.09 -112.299)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6212",
    "data-name": "Group 6212",
    transform: "translate(3.2 2.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15281",
    "data-name": "Path 15281",
    d: "M248.911,95.919c-.467,5.866-.787,8.339,1.674,11.73,3.7,5.1,10.873,4.362,13.05-1.253,1.959-5.055,2.394-13.8-2.865-16.9a7.9,7.9,0,0,0-11.86,6.421Z",
    transform: "translate(-248.587 -88.388)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15282",
    "data-name": "Path 15282",
    d: "M250.119,101.314c-2.941-.782-1.785-3.82-1.785-3.82l4.332.672S253.06,102.089,250.119,101.314Z",
    transform: "translate(-245.306 -87.658)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15283",
    "data-name": "Path 15283",
    d: "M261.618,89.572s-.075,3.244-4.055,3.417-3.678,6.26-8.086,5.125c-5.443-1.4-3.381-6.05-2.068-8.065C248.243,88.767,257.147,81.079,261.618,89.572Z",
    transform: "translate(-244.93 -85.632)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6213",
    "data-name": "Group 6213",
    transform: "translate(12.263 16.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15284",
    "data-name": "Path 15284",
    d: "M263.058,107.851s-2.857-1.292-3.486-2.536c0,0-.42,2.226,1.078,3.046A1.808,1.808,0,0,0,263.058,107.851Z",
    transform: "translate(-259.518 -105.315)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6214",
    "data-name": "Group 6214",
    transform: "translate(13.164 11.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15285",
    "data-name": "Path 15285",
    d: "M260.617,100.465c-.066.473.131.893.44.936s.614-.305.681-.779-.13-.893-.44-.936-.614.3-.681.779Z",
    transform: "translate(-260.605 -99.682)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6215",
    "data-name": "Group 6215",
    transform: "translate(17.977 12.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15286",
    "data-name": "Path 15286",
    d: "M266.421,101.408c-.066.473.131.893.44.937s.614-.305.681-.779-.13-.893-.44-.936-.614.3-.681.778Z",
    transform: "translate(-266.409 -100.626)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6216",
    "data-name": "Group 6216",
    transform: "translate(18.53 12.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15287",
    "data-name": "Path 15287",
    d: "M267.076,100.6l1.183-.168s-.708.808-1.183.168Z",
    transform: "translate(-267.076 -100.435)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6217",
    "data-name": "Group 6217",
    transform: "translate(15.675 13.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15288",
    "data-name": "Path 15288",
    d: "M264.18,101.451s.64,1.37,1.373,2.584a.717.717,0,0,1-.379,1.057,7.107,7.107,0,0,1-1.542.294Z",
    transform: "translate(-263.632 -101.451)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6218",
    "data-name": "Group 6218",
    transform: "translate(0.772 10.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15289",
    "data-name": "Path 15289",
    d: "M245.776,101.351a3.777,3.777,0,0,0,2,2.375c1.242.542,2.084-.784,1.923-2.275-.145-1.341-.965-3.24-2.3-3.14-1.315.1-2.04,1.684-1.624,3.041Z",
    transform: "translate(-245.659 -98.306)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15290",
    "data-name": "Path 15290",
    d: "M249.215,103.661a.793.793,0,1,1-.793-.793A.793.793,0,0,1,249.215,103.661Z",
    transform: "translate(-245.224 -88.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6219",
    "data-name": "Group 6219",
    transform: "translate(11.599 9.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15291",
    "data-name": "Path 15291",
    d: "M259,98.051a.28.28,0,0,0,.2-.088,2.239,2.239,0,0,1,1.891-.738.281.281,0,1,0,.1-.553,2.788,2.788,0,0,0-2.4.9.282.282,0,0,0,.206.474Z",
    transform: "translate(-258.717 -96.65)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6220",
    "data-name": "Group 6220",
    transform: "translate(17.868 9.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15292",
    "data-name": "Path 15292",
    d: "M268.607,99.047a.281.281,0,0,0,.244-.455,2.786,2.786,0,0,0-2.321-1.09.281.281,0,0,0,.056.559,2.223,2.223,0,0,1,1.828.884.278.278,0,0,0,.194.1Z",
    transform: "translate(-266.277 -97.497)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6221",
    "data-name": "Group 6221",
    transform: "translate(13.718 11.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15293",
    "data-name": "Path 15293",
    d: "M261.272,99.66l1.183-.168s-.708.807-1.183.168Z",
    transform: "translate(-261.272 -99.492)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_15275",
    "data-name": "Path 15275",
    d: "M263.4,172.174c0,3.3-24.22,4.859-38.631.108.24-.9.58-2.454.788-3.358q.162-.634.3-1.294c.3-1.443.539-3.018.755-4.726a1.2,1.2,0,0,1,.033-.232q.373-3.271.514-7.114c.033-.937.058-1.891.066-2.877.008-.945.008-1.915-.008-2.919-.008-.672-.017-1.352-.041-2.048-.017-.572-.041-1.144-.075-1.733-.058-1.468-.149-2.977-.274-4.519-.124-1.592-.274-3.209-.464-4.876v-.008q-.51-4.527-1.352-9.361a7.743,7.743,0,0,1,7.081-9.079c1.236-.083,2.529-.141,3.864-.166,1.327-.008,2.6-.041,3.839-.041a78.745,78.745,0,0,1,10.074.473c.249.033.5.066.763.1,1.252.166,2.521.373,3.764.58,5.323.92,7.628,4.61,7.811,10.995.207,7.089,5.6,11.526-1.219,16.293C260.108,152.423,263.4,162.879,263.4,172.174Z",
    transform: "translate(-194.55 -91.149)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_15294",
    "data-name": "Path 15294",
    d: "M244.653,117.821a4.948,4.948,0,0,0-4.543.025l5.5,8.371s-.661-1.769,1.952-1.537a25.136,25.136,0,0,1,4.879.961S247.519,120.583,244.653,117.821Z",
    transform: "translate(-150.096 -91.025)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15295",
    "data-name": "Path 15295",
    d: "M244.653,117.821a4.948,4.948,0,0,0-4.543.025l5.5,8.371s-.661-1.769,1.952-1.537a25.136,25.136,0,0,1,4.879.961S247.519,120.583,244.653,117.821Z",
    transform: "translate(-150.096 -91.025)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15296",
    "data-name": "Path 15296",
    d: "M255.263,118.54s1.494,4.562-.28,7.312c0,0,3.371-2.036,4.258-1.816s.665,1.595.665,1.595,1.568-2.883.607-4.968S255.263,118.54,255.263,118.54Z",
    transform: "translate(-152.637 -91.237)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15297",
    "data-name": "Path 15297",
    d: "M255.263,118.54s1.494,4.562-.28,7.312c0,0,3.371-2.036,4.258-1.816s.665,1.595.665,1.595,1.568-2.883.607-4.968S255.263,118.54,255.263,118.54Z",
    transform: "translate(-152.637 -91.237)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6225",
    "data-name": "Group 6225",
    transform: "translate(0 22.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15298",
    "data-name": "Path 15298",
    d: "M184.871,352.454l-1.12,2.618-.192-240.526h1.313Z",
    transform: "translate(-140.436 -112.879)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15299",
    "data-name": "Path 15299",
    d: "M176.268,119.7s-12.84-4.546-21.431,3.878c-15.743,15.435-23.285,7.178-23.285,7.178s3.282,16.9,19.781,8.615a35.023,35.023,0,0,1,24.935-2.415C176.907,136.958,176.907,119.7,176.268,119.7Z",
    transform: "translate(-131.552 -113.551)",
    fill: "#962cc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15300",
    "data-name": "Path 15300",
    d: "M185.673,114.2a1.667,1.667,0,1,1-1.667-1.667A1.667,1.667,0,0,1,185.673,114.2Z",
    transform: "translate(-140.228 -112.536)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15301",
    "data-name": "Path 15301",
    d: "M185.673,114.2a1.667,1.667,0,1,1-1.667-1.667A1.667,1.667,0,0,1,185.673,114.2Z",
    transform: "translate(-140.228 -112.536)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15302",
    "data-name": "Path 15302",
    d: "M187.872,177.079s-2.163-.613-3.172-.818-3.04,1.6-2.886,2.293c.216.977,2.128-.216,2.128-.216l.111,6.523a9.368,9.368,0,0,0,2.85-1.209C190.226,181.64,189.638,178.413,187.872,177.079Z",
    transform: "translate(-140.137 -101.208)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15303",
    "data-name": "Path 15303",
    d: "M183.358,177.47s-1.458-.687-1.88.17-.273,5.892.337,7.1,2.349.575,2.581-.336S185.241,178.6,183.358,177.47Z",
    transform: "translate(-140.04 -101.374)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg5);
export default __webpack_public_path__ + "static/media/img5.9c76743bb0a8a52a05274a0d9b02616e.svg";
export { ForwardRef as ReactComponent };